export function Spinner({ label }: { label?: string }) {
  return (
    <span className="row" role={label ? "status" : undefined}>
      <span className="spinner" aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </span>
  );
}

export function FullPageSpinner({ label = "Loading" }: { label?: string }) {
  return (
    <div className="full-page-center">
      <Spinner label={label} />
    </div>
  );
}
